import { useState, useEffect } from "react";
import { api } from "../Components/functions/Api";

/**
 * Hook to fetch news articles for a given market.
 * Uses the backend /news endpoint which caches for 24hrs.
 * @param {string} marketId - e.g. "btc", "los-angeles", "rolex"
 * @returns {{ articles: Array, loading: boolean, error: string|null }}
 */
const useAssetNews = (marketId) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!marketId) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchNews = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await api("news", { marketId });
        if (!cancelled) {
          setArticles(data.articles || []);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("Failed to fetch news:", err);
          setError("Failed to load news");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchNews();

    return () => {
      cancelled = true;
    };
  }, [marketId]);

  return { articles, loading, error };
};

export default useAssetNews;
